import {
  Directive,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  HostListener,
  Input,
} from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import {
  bullStylesSAG,
  bullStylesSHS,
  rangeThumbDisabledStylesSAG,
  rangeThumbDisabledStylesSHS,
  rangeThumbStylesSAG,
  rangeThumbStylesSHS,
} from './range-thumb.styles';

@Directive({
  selector: '[sag-ui-range-thumb]',
})
export class RangeThumbDirective implements OnInit {
  @Input() disabled = false;
  private bull: HTMLElement | null = null;

  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit(): void {
    const rangeThumbStyles = componentStylesByTheme(
      this.theme,
      rangeThumbStylesSAG,
      rangeThumbStylesSHS
    );

    const rangeThumbDisabledStyles = componentStylesByTheme(
      this.theme,
      rangeThumbDisabledStylesSAG,
      rangeThumbDisabledStylesSHS
    );
    style(
      this.elementRef,
      this.disabled ? rangeThumbDisabledStyles() : rangeThumbStyles()
    );

    const bullStyles = componentStylesByTheme(
      this.theme,
      bullStylesSAG,
      bullStylesSHS
    );

    this.bull = this.renderer.createElement('div');
    this.renderer.setStyle(this.bull, 'display', 'none');
    this.renderer.setAttribute(this.bull, 'class', bullStyles());
    this.renderer.appendChild(this.elementRef.nativeElement, this.bull);
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (!this.bull || this.disabled) return;
    this.renderer.setStyle(this.bull, 'display', 'block');
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (!this.bull) return;
    this.renderer.setStyle(this.bull, 'display', 'none');
  }

  public nativeElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }
}
